(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["magic-page-designer"] = factory(require("vue"));
	else
		root["magic-page-designer"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 